import { environment } from '../../environments/environment';

/** Guarda en BD solo la ruta relativa (sin dominio). */
export function normalizarRutaMedia(url: string): string {
  if (!url) {
    return '';
  }
  const trimmed = url.trim();
  if (trimmed.startsWith('assets/')) {
    return trimmed;
  }
  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      return new URL(trimmed).pathname;
    } catch (e) {
      return trimmed;
    }
  }
  return trimmed.startsWith('/') ? trimmed : '/' + trimmed;
}

/** Arma la URL completa usando environment.url. */
export function resolverUrlMedia(url: string): string {
  if (!url) {
    return '';
  }
  const trimmed = url.trim();
  if (trimmed.startsWith('assets/')) {
    return trimmed;
  }

  const base = environment.url.replace(/\/$/, '');

  if (trimmed.startsWith('http://') || trimmed.startsWith('https://')) {
    try {
      const pathname = new URL(trimmed).pathname;
      if (pathname.startsWith('/storage/')) {
        return base + pathname;
      }
      return trimmed;
    } catch (e) {
      return trimmed;
    }
  }

  const path = trimmed.startsWith('/') ? trimmed : '/' + trimmed;
  return base + path;
}



// WEBPACK FOOTER //
// E:/R1/Angular/turnero/web-visor-cliente/src/app/utils/media-url.util.ts